import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const Fullscreen2Icon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "fullscreen-2",
  "Fullscreen2Icon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.66683 5.66665V6.33331H1.3335V5.66665V1.99998V1.33331H2.00016H5.66683H6.3335V2.66665H5.66683H2.66683L2.66683 5.66665ZM13.3335 5.66665V6.33331H14.6668V5.66665V1.99998V1.33331H14.0002H10.3335H9.66683V2.66665H10.3335H13.3335V5.66665ZM2.66683 9.66665V10.3333L2.66683 13.3333H5.66683H6.3335V14.6666H5.66683H2.00016H1.3335V14V10.3333V9.66665H2.66683ZM13.3335 10.3333V9.66665H14.6668V10.3333V14V14.6666H14.0002H10.3335H9.66683V13.3333H10.3335H13.3335V10.3333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd"/></g></svg>
);

export default Fullscreen2Icon;
